import { render } from "./InfoScheme.vue?vue&type=template&id=e97f574a&scoped=true&ts=true"
import script from "./InfoScheme.vue?vue&type=script&lang=ts"
export * from "./InfoScheme.vue?vue&type=script&lang=ts"

import "./InfoScheme.vue?vue&type=style&index=0&id=e97f574a&scoped=true&lang=css"

import exportComponent from "C:\\BuildAgent\\work\\2f08168a1cda37d3\\Loading\\loading_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e97f574a"]])

export default __exports__